wbApp.directive('wbSparkline', [function () {
    'use strict';
    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            opts: '='
        },
        link: function (scope, elem, attrs, ctrl) {

            var opts = { type: 'line' };

            var render = function () {
                var model;
                //if (attrs.opts) angular.extend(opts, angular.fromJson(attrs.opts));
                angular.extend(opts, scope.opts);
                //console.log(opts);
                // Trim trailing comma if we are a string
                angular.isString(ctrl.$viewValue) ? model = ctrl.$viewValue.replace(/(^,)|(,$)/g, "") : model = ctrl.$viewValue;
                var data;
                // Make sure we have an array of numbers
                angular.isArray(model) ? data = model : data = model.split(',');
                $(elem).sparkline(data, opts);
            };

            ctrl.$render = function () {
                render();
            }

            scope.$watch(opts, function () {
                render();
            });
        }
    }
}]);
